import { postInfo, getInfo } from './api';

export default {
  /** 部门管理 */
  reqDepartNameList(data, url) { // 部门名称列表
    const nurl = url || '';
    return getInfo(`hr/depart/name/list${nurl}`, data);
  },
  reqDeparts(data, url) { // 部门名称列表
    const nurl = url || '';
    return getInfo(`hr/departs${nurl}`, data);
  },
  reqDepartManagerList(data, url) { // 部门负责人列表
    const nurl = url || '';
    return getInfo(`hr/depart/manager/list${nurl}`, data);
  },
  reqDepartList(data, url) { // 分页查询部门信息
    const nurl = url || '';
    return postInfo(`hr/depart/list${nurl}`, data);
  },
  reqDepartInsert(data, url) { // 新增部门保存
    const nurl = url || '';
    return postInfo(`hr/depart/insert${nurl}`, data);
  },
  reqDepartModify(data, url) { // 修改部门
    const nurl = url || '';
    return postInfo(`hr/depart/modify${nurl}`, data);
  },
  reqStaffNameList(data, url) { // 新增部门  负责人接口
    const nurl = url || '';
    return getInfo(`hr/staff/name/list${nurl}`, data);
  },
  reqDepartShut(data, url) { // 停用部门
    const nurl = url || '';
    return postInfo(`hr/depart/shut${nurl}`, data);
  },
  reqOrgStruct(data, url) { // 刷新图表
    const nurl = url || '';
    return getInfo(`hr/org/struct${nurl}`, data);
  },
  /** 职级管理 */
  reqRankSeqNameList(data, url) { // 序列
    const nurl = url || '';
    return getInfo(`hr/rankSeq/name/list${nurl}`, data);
  },
  reqRankNameList(data, url) { // 请求职级
    const nurl = url || '';
    return postInfo(`hr/rank/name/list${nurl}`, data);
  },
  reqRankGradeList(data, url) { // 请求职级分页查询
    const nurl = url || '';
    return postInfo(`hr/rankGrade/list${nurl}`, data);
  },
  reqRankGradeInsert(data, url) { // 职级新增
    const nurl = url || '';
    return postInfo(`hr/rankGrade/insert${nurl}`, data);
  },
  reqRankGradeModify(data, url) { // 职级修改
    const nurl = url || '';
    return postInfo(`hr/rankGrade/modify${nurl}`, data);
  },
  reqRankGradeStart(data, url) { // 职级启用
    const nurl = url || '';
    return postInfo(`hr/rankGrade/start${nurl}`, data);
  },
  reqRankGradeShut(data, url) { // 职级停用
    const nurl = url || '';
    return postInfo(`hr/rankGrade/shut${nurl}`, data);
  },
  reqRankGradeRemove(data, url) { // 职级删除
    const nurl = url || '';
    return postInfo(`hr/rankGrade/remove${nurl}`, data);
  },
  reqJobRankRecordList(data, url) { // 职级操作详情
    const nurl = url || '';
    return postInfo(`hr/jobRankRecord/list${nurl}`, data);
  },
  /** 职等管理 */
  reqGradeTypeNameList(data, url) { // 职等类型list
    const nurl = url || '';
    return getInfo(`hr/grade/type/name/list${nurl}`, data);
  },
  reqGradeNameList(data, url) { // 职等list
    const nurl = url || '';
    return postInfo(`hr/grade/name/list${nurl}`, data);
  },
  reqGradeList(data, url) { // 职等分页查询
    const nurl = url || '';
    return postInfo(`hr/grade/list${nurl}`, data);
  },
  reqGradeInsert(data, url) { // 职等新增
    const nurl = url || '';
    return postInfo(`hr/grade/insert${nurl}`, data);
  },
  reqGradeModify(data, url) { // 职等修改
    const nurl = url || '';
    return postInfo(`hr/grade/modify${nurl}`, data);
  },
  reqGradeShut(data, url) { // 职等停用
    const nurl = url || '';
    return postInfo(`hr/grade/shut${nurl}`, data);
  },
  reqGradeStart(data, url) { // 职等启用
    const nurl = url || '';
    return postInfo(`hr/grade/start${nurl}`, data);
  },
  reqGradeRemove(data, url) { // 职等启用
    const nurl = url || '';
    return postInfo(`hr/grade/remove${nurl}`, data);
  },
  reqJobGradeRecordList(data, url) { // 职等启用
    const nurl = url || '';
    return postInfo(`hr/jobGradeRecord/list${nurl}`, data);
  },
  /** 岗位管理 */
  reqPositionList(data, url) { // 分页查询岗位管理
    const nurl = url || '';
    return postInfo(`hr/position/list${nurl}`, data);
  },
  reqPositionInsert(data, url) { // 岗位新增
    const nurl = url || '';
    return postInfo(`hr/position/insert${nurl}`, data);
  },
  reqPositionModify(data, url) { // 岗位修改
    const nurl = url || '';
    return postInfo(`hr/position/modify${nurl}`, data);
  },
  reqPositionRemove(data, url) { // 岗位修改
    const nurl = url || '';
    return postInfo(`hr/position/remove${nurl}`, data);
  },
  reqRoleBindedPosition(data, url) { // 获取已授权
    const nurl = url || '';
    return getInfo(`auth2/role/bindedPosition${nurl}`, data);
  },
  reqRoleNoBinded(data, url) { // 获取未授权
    const nurl = url || '';
    return getInfo(`auth2/role/noBinded${nurl}`, data);
  },
  reqPositionRoleInsert(data, url) { // 岗位角色添加
    const nurl = url || '';
    return postInfo(`hr/position/role/insert${nurl}`, data);
  },
  reqPositionStaffList(data, url) { // 岗位员工查询
    const nurl = url || '';
    return postInfo(`hr/position/staff/list${nurl}`, data);
  },
  reqStaffSizeConfigList(data, url) { // 岗位配置列表
    const nurl = url || '';
    return postInfo(`hr/position/depart/list${nurl}`, data);
  },
  reqStaffSizeConfigAdd(data, url) { // 岗位配置列表
    const nurl = url || '';
    return postInfo(`hr/position/depart/insert${nurl}`, data);
  },
  reqStaffSizeConfigChange(data, url) { // 岗位配置列表修改
    const nurl = url || '';
    return postInfo(`hr/position/depart/modify${nurl}`, data);
  },
  reqStaffSizeConfigDelete(data, url) { // 岗位配置列表删除
    const nurl = url || '';
    return postInfo(`hr/position/depart/remove${nurl}`, data);
  },
  /** 职位管理 */
  reqTitleList(data, url) { // 职位分页查询
    const nurl = url || '';
    return postInfo(`hr/title/list${nurl}`, data);
  },
  reqTitleNameList(data, url) { // 获取职位
    const nurl = url || '';
    return getInfo(`hr/title/name/list${nurl}`, data);
  },
  reqPositionNameList(data, url) { // 获取岗位
    const nurl = url || '';
    return getInfo(`hr/position/name/list${nurl}`, data);
  },
  reqTitleInsert(data, url) { // 职位新增
    const nurl = url || '';
    return postInfo(`hr/title/insert${nurl}`, data);
  },
  reqTitleModify(data, url) { // 职位修改
    const nurl = url || '';
    return postInfo(`hr/title/modify${nurl}`, data);
  },
  reqTitleRemove(data, url) { // 职位删除
    const nurl = url || '';
    return postInfo(`hr/title/remove${nurl}`, data);
  },
  reqTitleStaffList(data, url) { // 职位查看
    const nurl = url || '';
    return postInfo(`hr/title/staff/list${nurl}`, data);
  },
  reqhrRoleNameList(data, url) { // 角色相关查询
    const nurl = url || '';
    return getInfo(`auth2/role/name/list${nurl}`, data);
  },
};
